import type { IdTokenClaims } from '#/lib/claims';

export type AuthState = {
  error: Error | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  // 判定・表示の元になる ID Token のカスタムクレーム。読み込み完了かつ認証済みのときに入る。
  claims: IdTokenClaims | null;
};

export const initialAuthState: AuthState = {
  error: null,
  isLoading: true,
  isAuthenticated: false,
  claims: null,
};
